<template>
  <b-container>
    <b-row>
      <video-item v-for="video in videos" :key="video.id" :video="video" />
    </b-row>
  </b-container>
</template>

<script lang="ts">
import GoogleApiService from "../services/GoogleApiService";
import VideoItem from "../components/VideoItem.vue";

export default {
  components: {
    VideoItem
  },
  props: {
    playlistId: String
  },
  data() {
    return {
      videos: []
    };
  },
  created() {
    GoogleApiService.GetGoogleVideos(this.playlistId).then(videos => {
      this.videos = videos;
    });
  }
};
</script>